import { Controller } from "stimulus"
import UnsavedChanges from "../unsaved_changes"
import { submitJsonForm, errorMessages } from "../form_submission"

export default class extends Controller {
  static targets = ["status"]

  connect() {
    this.unsavedChanges = new UnsavedChanges(this.element)
  }

  disconnect() {
    this.unsavedChanges.disconnect()
  }

  save(event) {
    submitJsonForm(event, {
      saving: () => this.saving(),
      success: (data) => this.success(data),
      error: (data) => this.error(data)
    })
  }

  saving() {
    this.commentFieldsPendingRemoval = this.destroyedCommentFields()
    this.setStatus("Saglabā...", "text-muted")
  }

  success(data) {
    this.persistCommentFieldIds(data.auditor_comment_fields || [])
    this.removeDestroyedCommentFields()
    this.updateAuditorPercentages(data.auditor_assessment_results_percentage || {})
    this.setStatus("Atskaites vērtējums saglabāts.", "text-success")
  }

  error(data) {
    this.commentFieldsPendingRemoval = []
    const explanation = errorMessages(data)
    this.setStatus(`Neizdevās saglabāt vērtējumu. ${explanation || "Lūdzu, mēģiniet vēlreiz."}`, "text-danger")
  }

  setStatus(message, statusClass) {
    this.statusTarget.textContent = message
    this.statusTarget.classList.remove("text-muted", "text-success", "text-danger")
    this.statusTarget.classList.add(statusClass)
  }

  persistCommentFieldIds(commentFields) {
    commentFields.forEach((commentField) => {
      const clientIdInput = this.clientIdInput(commentField.client_id)
      if (!clientIdInput) return

      const idInputName = clientIdInput.name.replace(/\[client_id\]$/, "[id]")
      if (this.formElement(idInputName)) return

      const idInput = document.createElement("input")
      idInput.type = "hidden"
      idInput.name = idInputName
      idInput.value = commentField.id
      clientIdInput.insertAdjacentElement("afterend", idInput)
    })
  }

  clientIdInput(clientId) {
    return Array.from(this.element.elements).find((element) => {
      return element.name.endsWith("[client_id]") && element.value === String(clientId)
    })
  }

  formElement(name) {
    return Array.from(this.element.elements).find((element) => element.name === name)
  }

  removeDestroyedCommentFields() {
    const commentFields = this.commentFieldsPendingRemoval || []
    commentFields.forEach((commentField) => commentField.remove())
    this.commentFieldsPendingRemoval = []
  }

  destroyedCommentFields() {
    return Array.from(this.element.querySelectorAll("[data-auditor-comment-field]")).filter((commentField) => {
      const destroyInput = commentField.querySelector("input[name$='[_destroy]']")
      return destroyInput && destroyInput.value === "1"
    })
  }

  updateAuditorPercentages(percentages) {
    const levels = ["first_level", "second_level", "third_level", "fourth_level"]

    levels.forEach((level) => {
      const value = percentages[level]
      if (typeof value !== "string") return

      this.element.ownerDocument
        .querySelectorAll(`[data-auditor-percentage="${level}"]`)
        .forEach((target) => { target.textContent = value })
    })
  }
}
